import { handleActions } from 'redux-actions'
import * as types from '../constants/ActionTypes'
const reducers = {}
const initialState = {
   policies:[]

}

reducers[types.GET_POLICIES_SUCCESS] = {
    next(state, action) {
         return Object.assign({}, state,{policies:action.payload.result})
    }
}
reducers[types.CLEAR_POLICIES] = (state, action) => {
    // next(state, action) {
    return Object.assign({}, state,{ policies: [] })
    // }
}

export default handleActions(reducers, initialState)